/**
 * Returns a JSON.stringify replace-compatible function that will prevent attempting to serialize circular dependencies
 * when generating JSON representation of complex objects.
 */
export const jsonStringifyCircularReplacerFactory = () => {
    const seen = new WeakSet();
    return (_key: string, value: any) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }

            seen.add(value);
        }

        return value;
    };
};

export const jsonStringifyWithoutCircularDependencies = (object: any) =>
    JSON.stringify(object, jsonStringifyCircularReplacerFactory());
